import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { List } from '@mui/material';
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import useSWR from 'swr';
import { ButtonWithoutBackgroundStyled } from '../../../theme/style';
import useFetcher from '../../../utils/hooks/useFetcher';
import EditInput from '../../EditInput/editInput';
import { ListIconStyled, ListItemStyled, ListItemTextStyled, SurveyCardShareStyled } from '../styled';
import { SurveyStatus, SurveyProps } from '../surveyInterface';

interface SurveyCardProps {
    id: string
    dashboardId: string[]
    survey?: SurveyProps
}

const SurveyCardWithApi: FC<SurveyCardProps> = ({ id, dashboardId, survey }) => {
    const { t } = useTranslation(['survey', 'dashboard']);
    const navigate = useNavigate();
    const [shareSurvey, setShareSurvey] = useState<{name: string, surveyid: number, customSurveyTitle: string, status: SurveyStatus} | undefined>(undefined);
    const { data: fetchedShareDashboard } = useSWR(`${process.env.REACT_APP_API_URL}/survey/${id}`, useFetcher());
    const urlToDashboard = fetchedShareDashboard && `/survey/${fetchedShareDashboard.surveyid}/dashboard/${dashboardId[0]}`;
    const urlToHotAlerts = survey && `/survey/${survey.surveyid}/hot-alerts/`;

    useEffect(() => {
        if (fetchedShareDashboard) {
            setShareSurvey(fetchedShareDashboard);
        }
    }, [fetchedShareDashboard]);

    return (
        <SurveyCardShareStyled key={id}>
            {shareSurvey && (
                <>
                    <EditInput showEditButton={false} surveyId={shareSurvey.surveyid} title={shareSurvey.customSurveyTitle ?? shareSurvey.name} />
                    <List>
                        <>
                            <ListItemStyled key="dashboardCount">
                                <ListIconStyled $hasHoverProp={dashboardId.length >= 1} onClick={() => (navigate(urlToDashboard))}>
                                    <DashboardOutlinedIcon />
                                </ListIconStyled>
                                <ListItemTextStyled primary={t('survey:surveyDashboard', { count: dashboardId.length })} />
                            </ListItemStyled>
                            {survey && (
                                <ListItemStyled key="dashboardCount">
                                    <ListIconStyled $hasHoverProp={survey.hotAlertCount && survey.hotAlertCount >= 1} onClick={() => (urlToHotAlerts && navigate(urlToHotAlerts))}>
                                        <NotificationsOutlinedIcon />
                                    </ListIconStyled>
                                    <ListItemTextStyled primary={survey.hotAlertCount === 0 ? t('survey:hotAlertCount', { count: 0 }) : t('survey:hotAlertCount', { count: survey.hotAlertCount }) + t('survey:toTreatHotAlertCount', { count: survey.toTreatHotAlertCount })} />
                                </ListItemStyled>
                            )}
                            <Link to={urlToDashboard}>
                                <ButtonWithoutBackgroundStyled sx={{ marginTop: '10px' }} disableRipple>{t('survey:seeResult')}</ButtonWithoutBackgroundStyled>
                            </Link>
                        </>
                    </List>
                </>
            )}
        </SurveyCardShareStyled>
    );
};

export default SurveyCardWithApi;
